<template>
  <div class="ReportArea">
    <div class="row">
      <div class="col-md-6">
        <div class="PagePanelDashboard">
          <OpenActivities
            :ref="openActivitiesRef"
            :dmaID="dmaID"
            :MarketName="dmaNameForFilter"
          />
        </div>
        <div class="PagePanelDashboard" v-if="livecount > 0">
          <div class="customeHeaderTitle">Channel Status</div>
          <div class="BarGraphDiv">
            <CCRChannelStatusChart
              :ref="ccrChannelStatusRef"
              :dmaID="dmaID"
              :dmaNameForFilter="dmaNameForFilter"
              :dmaNameAndRank="dmaNameAndRank"
            />
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="PagePanelDashboard">
          <div class="customeHeaderTitle">Location Information</div>
          <MapRadar v-if="mapData" :mapData="mapData" />
          <div class="row" style="padding-left: 13px" v-if="mapData">
            <div class="col-md-6">
              <span style="padding-right: 9px">
                <img
                  src="../../../../src/assets/img/Home.svg"
                  class="iconImg"
                />
              </span>
              <span>
                {{ numberWithCommas(mapData.Household_Pop) }} Households
              </span>
            </div>
            <div class="col-md-6">
              <span style="padding-right: 9px; cursor: pointer">
                <img
                  src="../../../../src/assets/img/US_Map.svg"
                  class="iconImg"
                />
              </span>
              <span>{{ mapData.Percent_US }}% of US population</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <DxLoadPanel
      :position="loaderPosition"
      :visible.sync="showLoadPanel"
      :show-indicator="true"
    />
  </div>
</template>
<script>
import { EventBus } from "../../../components/Events";
import MapRadar from "../dashboardCharts/MapRadar.vue";
// import InstallationProgChart from "../dashboardCharts/InstallationProgChart.vue";
import CCRChannelStatusChart from "../dashboardCharts/channelStatus/CCRChannelStatusChart.vue";
import ChannelUptimeChart from "../dashboardCharts/ChannelUptimeChart.vue";
import OpenActivities from "../../home/homeDashboard/dashboard/OpenActivities/OpenActivities.vue";
import { DxLoadPanel } from "devextreme-vue/load-panel";
export default {
  name: "CCRDashboardSection",
  components: {
    MapRadar,
    // InstallationProgChart,
    CCRChannelStatusChart,
    ChannelUptimeChart,
    OpenActivities,
    DxLoadPanel,
  },
  data() {
    return {
      loaderPosition: { of: ".ReportArea" },
      isMounted: false,
      openActivitiesRef: "openActivitiesRef",
      ccrChannelStatusRef: "ccrChannelStatusRef",
      installDetails: [],
      installationChartData: [],
      user: this.$auth.user.UserDetails,
      chartCenterText: "0/0",
      numberOfChannelVerification: 0,
      serviceTicketsCount: 0,
      serviceTicketsData: [],
      monthToDate: "Month-to-Date",
      quarterToDate: "Quarter-to-Date",
      livecount: 0,
      numberOfChannelRejected: 0,
      // openEvents: "",
      // scheduleEvents: "",
      MarketID: this.$route.params.MarketName,
    };
  },
  props: {
    dmaID: Number,
    dmaNameForFilter: String,
    dmaNameAndRank: String,
    mapData: Object,
  },
  computed: {
    showLoadPanel() {
      return this.isOpenActivitiesLoaded || this.isChannelsStatusLoaded;
    },
    isOpenActivitiesLoaded() {
      if (this.isMounted) {
        return this.$refs.openActivitiesRef?.loaderVisible ?? false;
      }
      return true;
    },
    isChannelsStatusLoaded() {
      if (this.isMounted) {
        return this.$refs.ccrChannelStatusRef?.loaderVisible ?? false;
      }
      return true;
    },
  },
  mounted: function () {
    this.isMounted = true;
    this.getPieChartData();
    this.getChannelVerificationCount();
  },
  watch: {},
  methods: {
    numberWithCommas(x) {
      return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getChannelVerificationCount() {
      let th = this;
      let fltr = `?$filter=(DMA_RecID eq ${this.dmaID})&$count=true`;
      let url = `https://api.ccr.net/ColoM360/ClientVerificationChannel_View${fltr}`;
      this.$axios.get(url).then((response) => {
        th.numberOfChannelVerification = response.data.value.filter(
          (ClientVerification) => ClientVerification.ClientVerification
        ).length;
        th.numberOfChannelRejected = response.data.value.filter(
          (ChannelReject) => ChannelReject.ChannelRejected == true
        ).length;
      });
    },
    getPieChartData() {
      let th = this;
      if (this.dmaID) {
        let fltr = `?$filter=(DMA_RecID eq ${this.dmaID})&$orderby= PhaseOrder`;
        let url = `https://api.ccr.net/ColoM360/M360Global_DMA_Dashboard_Phase_View${fltr}`;
        this.$axios.get(url).then((response) => {
          th.installationChartData = response.data.value;
          th.installationChartData.forEach((element) => {
            let obj = {
              color: `${element.PhaseColor}`,
              text: `${element.PhaseName}`,
              val: `${element.PhaseChannelCount}`,
            };
            th.installDetails.push(obj);
            if (element.PhaseName == "Live") {
              th.livecount = element.PhaseChannelCount;
              th.chartCenterText =
                element.PhaseChannelCount + "/" + element.DMAChannelCount;
            }
          });
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.ReportArea {
  background-color: #f1f1f1;
  color: black;
  margin: -4px 8px;
}
.PagePanelDashboard {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin: 0;
  border: 1px solid lightgray;
  padding: 15px;
  background-color: white;
  margin-bottom: 8px;
  min-height: 195px;
}
.GraphDetails {
  display: inline-block;
  width: 280px;
  text-align: left;
  margin-top: 5px;
  margin-left: 60px;
}
.ChartItem {
  width: 75%;
  font-size: 16px;
  margin-left: 10px;
  padding: 8px;
}
.GraphDiv {
  display: inline-block;
  width: 35%;
  text-align: left;
}
.ItemDivider {
  border-top: 2px solid lightgray !important;
}
.BarGraphDiv {
  width: 100%;
  text-align: right;
}
.BarGraphDivUptime {
  display: inline-block;
  width: 50%;
  height: 50%;
  text-align: right;
}
.iconImg {
  height: 23px;
  width: 23px;
  vertical-align: top;
}
.ReportArea ::v-deep {
  .col-md-6,
  .col-md-12 {
    padding: 4px;
  }
  .row {
    padding: 0;
  }
  .col-md-6 {
    padding-bottom: 20px;
  }
}
.install {
  display: flex;
  width: 100%;
}
</style>